import {
    browserTracingIntegration,
    captureException, captureMessage, getCurrentScope, getGlobalScope, init,
    replayIntegration,
    setContext, setTag, setUser, withScope
} from "@sentry/capacitor";
import { captureConsoleIntegration, init as initVue, vueIntegration } from "@sentry/vue";
import { App } from "vue";
import { AdditionalInitInfo, SentryInit, SentryMethods } from "./monitoring-types";

export const provideFrontendSentryMethods = (): SentryMethods => {
    return {
        captureException,
        captureMessage,
        getCurrentScope,
        getGlobalScope,
        setContext,
        setTag,
        setUser,
        withScope,
        captureConsoleIntegration,
    };
};

const provideIntegrations = (app: App) => {
    return [
        replayIntegration({ maskAllText: true, blockAllMedia: true }),
        vueIntegration({ app, tracingOptions: { trackComponents: true }, attachProps: true }),
        browserTracingIntegration()
    ];
};

export const provideFrontendInit = (options: SentryInit & { app: App; }) => {
    const { app, dsn, environment, release, enabled } = options;

    const initOptions = {
        enabled: enabled ?? true, // TODO: set from environment variable development/production
        app,
        dsn,
        environment,
        release,
        integrations: provideIntegrations(app),
        tracesSampleRate: 1.0,
        tracePropagationTargets: ["localhost"],
    };

    return (additionaInitInfo: AdditionalInitInfo) => {
        const { errorSamplingRate, captureConsoleEnabled } = additionaInitInfo;

        if (captureConsoleEnabled) {
            initOptions.integrations.push(captureConsoleIntegration({ levels: ["error"] }));
        }
        init({
            ...initOptions,
            replaysOnErrorSampleRate: errorSamplingRate,
            replaysSessionSampleRate: 0.1
        }, initVue);
    };
};